const LobbyManager = {
    version: "1.2.1-sync-refined",
    elements: {},

    // [SAFE UTILS] Prevent ReferenceError
    utils: window.utils || { isMobile: () => false, showConfirm: (m, c) => confirm(m) && c() },

    init: function () {
        console.log("LobbyManager: Init called");
        this.cacheElements();
        this.setupListeners();

        // [DEEP LINKING] Check State for Auto Panel Switch
        if (window.state && window.state.lobbyAction) {
            const action = window.state.lobbyAction;
            // Delay slightly to ensure UI is ready
            setTimeout(() => {
                if (action === 'create') this.switchPanel('create', false); // false = don't push state again
                else if (action === 'join') {
                    this.switchPanel('join', false);
                    this.refreshServerList();
                }
                // Reset state so it doesn't trigger again weirdly
                window.state.lobbyAction = null;
            }, 100);
        }
    },

    cacheElements: function () {
        this.elements = {
            // Panels
            lobbyScreen: document.getElementById('lobby-screen'),
            lobbyMain: document.getElementById('lobby-main-actions'),
            createPanel: document.getElementById('create-room-panel'),
            joinPanel: document.getElementById('join-room-panel'),
            listContainer: document.getElementById('server-list-container'),
            playersList: document.getElementById('connected-players'), // For In-Lobby list (if visible)

            // Buttons
            btnShowCreate: document.getElementById('show-create-panel-btn'),
            btnShowJoin: document.getElementById('show-join-panel-btn'),
            btnCancelCreate: document.getElementById('cancel-create-btn'),
            btnCancelJoin: document.getElementById('cancel-join-btn'),
            btnConfirmCreate: document.getElementById('confirm-create-btn'),
            btnConfirmJoin: document.getElementById('confirm-join-btn'),
            btnRefreshList: document.getElementById('refresh-list-btn'),
            // [NEW] Ready Button
            btnReady: document.getElementById('lobby-ready-btn'),
            playersListLabel: document.getElementById('players-list-label'),

            // Inputs
            inputRoomId: document.getElementById('join-room-id'),
            inputPlayerName: document.getElementById('join-player-name'), // In Join Panel

            // Create Form
            selectMode: document.getElementById('multi-mode-select'),
            selectCategory: document.getElementById('multi-category-select'),
            selectCapacity: document.getElementById('multi-capacity-select'),
            selectTime: document.getElementById('multi-time-select'),
            selectPrivacy: document.getElementById('multi-privacy-select'),
            categoryRow: document.getElementById('multi-category-row'),
            // [NEW] Waiting Room Elements
            wrModeSelect: document.getElementById('wr-mode-select'),
            wrModeBadge: document.getElementById('wr-mode-badge'),
            wrSwitchWheelBtn: document.getElementById('wr-switch-wheel-btn'),
            wrSwitchRouletteBtn: document.getElementById('wr-switch-roulette-btn'),
            wrAutoSpinBtn: document.getElementById('wr-auto-spin-btn'),
            wrSpinBtn: document.getElementById('wr-spin-btn'),
            wrSpinResultText: document.getElementById('wr-spin-result-text'),
            wrWheelArea: document.getElementById('wr-wheel-area')
        };
    },

    setupListeners: function () {
        // Navigation Buttons
        if (this.elements.btnShowCreate) {
            this.elements.btnShowCreate.onclick = () => {
                if (window.audio) window.audio.playSound('buttons');
                this.switchPanel('create', false);
            };
        }
        if (this.elements.btnShowJoin) {
            this.elements.btnShowJoin.onclick = () => {
                if (window.audio) window.audio.playSound('buttons');
                this.switchPanel('join', false);
                this.refreshServerList();
            };
        }
        if (this.elements.btnCancelCreate) {
            this.elements.btnCancelCreate.onclick = () => {
                if (window.audio) window.audio.playSound('buttons');
                this.switchPanel('main', false);
            };
        }
        if (this.elements.btnCancelJoin) {
            this.elements.btnCancelJoin.onclick = () => {
                if (window.audio) window.audio.playSound('buttons');
                this.switchPanel('main', false);
            };
        }

        // Action Buttons
        if (this.elements.btnRefreshList) {
            this.elements.btnRefreshList.onclick = () => this.refreshServerList();
        }

        if (this.elements.btnConfirmCreate) {
            this.elements.btnConfirmCreate.onclick = () => {
                if (window.audio) window.audio.playSound('buttons');
                this.createRoom();
            };
        }

        if (this.elements.btnConfirmJoin) {
            this.elements.btnConfirmJoin.onclick = () => {
                if (window.audio) window.audio.playSound('buttons');
                this.joinRoom();
            };
        }

        // [NEW] Ready Button Listener
        if (this.elements.btnReady) {
            this.elements.btnReady.onclick = () => {
                if (window.multiplayer && window.multiplayer.room) {
                    console.log("Sending Ready Signal...");
                    if (window.audio) window.audio.playSound('ready_go');
                    window.multiplayer.room.send("ready");
                }
            };
        }

        // [NEW] Start Button Listener (Host)
        const btnStart = document.getElementById('lobby-start-game-btn');
        if (btnStart) {
            btnStart.onclick = () => {
                if (window.multiplayer) {
                    window.multiplayer.startGame();
                }
            };
        }

        // [NEW] Mode Change Listener (Create Room Panel)
        if (this.elements.selectMode && this.elements.categoryRow) {
            const toggleCategory = () => {
                const mode = this.elements.selectMode.value;
                const isWheel = mode === 'wheel';
                const isRoulette = mode === 'roulette';
                this.elements.categoryRow.style.display = (isWheel || isRoulette) ? 'none' : 'block';

                // Roulette always requires 4 players
                if (isRoulette && this.elements.selectCapacity) {
                    this.elements.selectCapacity.value = '4';
                    this.elements.selectCapacity.disabled = true;
                } else if (this.elements.selectCapacity) {
                    this.elements.selectCapacity.disabled = false;
                }
            };
            this.elements.selectMode.onchange = toggleCategory;
            toggleCategory(); // Run immediately to set initial state
        }

        // [NEW] Competition Button Listener
        const btnCompetition = document.getElementById('show-competition-btn');
        if (btnCompetition) {
            btnCompetition.onclick = () => {
                console.log("LobbyManager: Competition button clicked");
                if (window.audio) window.audio.playSound('buttons');
                if (window.MatchmakingManager) {
                    window.MatchmakingManager.showPanel();
                }
            };
        }

    },

    // [SYNC FIX] Setup listeners for Waiting Room settings (Host Only)
    setupWaitingRoomListeners: function () {
        console.log("LobbyManager: Setting up Waiting Room Listeners...");
        const els = {
            category: document.getElementById('wr-category-select'),
            mode: document.getElementById('wr-mode-select'),
            time: document.getElementById('wr-time-select'),
            capacity: document.getElementById('wr-max-players-select'),
            privacy: document.getElementById('wr-privacy-select')
        };

        // Host Start Button - Re-bind in case of re-render
        const btnStart = document.getElementById('lobby-start-game-btn');
        if (btnStart) {
            btnStart.onclick = () => {
                console.log("Host clicked Start Game");
                if (window.multiplayer) window.multiplayer.startGame();
            };
        }

        // [FIX] Ready Button - Re-bind in case of re-render (for guests)
        const btnReady = document.getElementById('lobby-ready-btn');
        if (btnReady) {
            btnReady.onclick = () => {
                console.log("Guest clicked Ready");
                if (window.audio) window.audio.playSound('ready_go');
                if (window.multiplayer && window.multiplayer.room) {
                    window.multiplayer.room.send("ready");
                }
            };
        }

        const updateOptions = () => {
            if (!window.multiplayer || !window.multiplayer.room) return;

            const payload = {};
            // [SYNC FIX] Removed visibility checks to ensure data is sent if event triggers
            if (els.category) payload.category = els.category.value;
            if (els.mode) payload.mode = els.mode.value;
            if (els.time) payload.turnTime = parseInt(els.time.value);
            if (els.capacity) payload.maxPlayers = parseInt(els.capacity.value);
            if (els.privacy) payload.isPrivate = (els.privacy.value === 'private');

            console.log("Sync Options:", payload);
            window.multiplayer.room.send("updateOptions", payload);
        };

        // Attach listeners
        if (els.mode) {
            els.mode.onchange = () => {
                if (window.audio) window.audio.playSound('categories');
                updateOptions();
            };
        }
        if (els.category) els.category.onchange = updateOptions;
        if (els.time) els.time.onchange = updateOptions;
        if (els.capacity) els.capacity.onchange = updateOptions;
        if (els.privacy) els.privacy.onchange = updateOptions;

        // [NEW] Waiting Room Chat Button Listener
        const chatBtn = document.getElementById('wr-chat-btn');
        if (chatBtn) {
            chatBtn.onclick = (e) => {
                e.stopPropagation();
                if (window.ChatManager) {
                    window.ChatManager.toggleMinimize(false);
                    if (window.ChatManager.container) {
                        window.ChatManager.container.classList.remove('hidden');
                    }
                }
            };
        }

        // [NEW] Wheel Mode Switch Button
        const wheelSwitchBtn = document.getElementById('wr-switch-wheel-btn');
        if (wheelSwitchBtn) {
            wheelSwitchBtn.onclick = (e) => {
                e.stopPropagation();
                if (window.multiplayer && window.multiplayer.room) {
                    if (window.audio) window.audio.playSound('categories');
                    const currentMode = window.multiplayer.room.state.mode;
                    const newMode = (currentMode === 'wheel') ? 'quiz' : 'wheel';
                    console.log(`Switching mode from ${currentMode} to ${newMode}...`);
                    window.multiplayer.room.send("updateOptions", { mode: newMode });
                }
            };
        }

        // [NEW] Roulette Mode Switch Button
        const rouletteSwitchBtn = document.getElementById('wr-switch-roulette-btn');
        if (rouletteSwitchBtn) {
            rouletteSwitchBtn.onclick = (e) => {
                e.stopPropagation();
                if (window.multiplayer && window.multiplayer.room) {
                    if (window.audio) window.audio.playSound('categories');
                    const currentMode = window.multiplayer.room.state.mode;
                    // Only allow switching to roulette from quiz or vice versa
                    const newMode = (currentMode === 'roulette') ? 'quiz' : 'roulette';
                    console.log(`Switching mode to ${newMode}...`);
                    window.multiplayer.room.send("updateOptions", { mode: newMode });
                }
            };
        }

        // [NEW] Wheel Mode Controls
        const spinBtn = document.getElementById('wr-spin-btn');
        const autoSpinBtn = document.getElementById('wr-auto-spin-btn');

        if (spinBtn) {
            spinBtn.onclick = () => {
                if (window.multiplayer && window.multiplayer.room) {
                    if (window.audio) window.audio.playSound('buttons');
                    window.multiplayer.room.send("requestSpin");
                } else if (window.wheel) {
                    window.wheel.spin();
                }
            };
        }

        if (autoSpinBtn) {
            autoSpinBtn.onclick = () => {
                if (window.multiplayer && window.multiplayer.room) {
                    window.multiplayer.room.send("requestAutoWheel");
                }
            };
        }

        // [NEW] Global Listener for Wheel Result (Sync Animation)
        if (window.multiplayer && window.multiplayer.room && !window.multiplayer.room._wheelListenersSet) {
            window.multiplayer.room.onMessage("wheelResult", (data) => {
                console.log("🎡 Sync Wheel Spin triggered:", data.winner);
                if (window.wheel) {
                    const resText = document.getElementById('wr-spin-result-text');
                    if (resText) resText.innerHTML = `<span style="color:rgba(255,255,255,0.4)">ÇEVRİLİYOR...</span>`;

                    window.wheel.spinOnline(data.winner, () => {
                        if (resText) resText.innerHTML = `SEÇİLEN: <span style="color:var(--accent-gold)">${data.winner.replace(/_/g, ' ').toUpperCase()}</span>`;
                    });
                }
            });

            window.multiplayer.room.onMessage("wheelClear", () => {
                const categoryList = document.getElementById('wr-collected-categories-list');
                if (categoryList) categoryList.innerHTML = '';
                const resText = document.getElementById('wr-spin-result-text');
                if (resText) resText.innerHTML = "ÇARK MODU";
            });

            window.multiplayer.room.onMessage("notification", (data) => {
                if (window.utils && window.utils.showToast) {
                    window.utils.showToast(data.message, data.type);
                }
            });

            window.multiplayer.room._wheelListenersSet = true;
        }
    },

    switchPanel: function (panel, updateUrl = true) {
        if (!this.elements.lobbyMain) this.cacheElements(); // Safety

        if (this.elements.lobbyMain) this.elements.lobbyMain.classList.add('hidden');
        if (this.elements.createPanel) this.elements.createPanel.classList.add('hidden');
        if (this.elements.joinPanel) this.elements.joinPanel.classList.add('hidden');

        if (panel === 'main' && this.elements.lobbyMain) {
            this.elements.lobbyMain.classList.remove('hidden');
        }
        if (panel === 'create' && this.elements.createPanel) {
            this.elements.createPanel.classList.remove('hidden');
        }
        if (panel === 'join' && this.elements.joinPanel) {
            this.elements.joinPanel.classList.remove('hidden');
        }

        // [FAILSAFE] Chat
        if (window.multiplayer && window.multiplayer.room && window.ChatManager) {
            if (!document.getElementById('online-chat-container')) {
                window.ChatManager.init(window.multiplayer.room, { startHidden: true });
            }
        }
    },

    createRoom: async function () {
        // [ROBUST CACHE] Always re-cache before creating room to catch dynamic DOM state
        this.cacheElements();

        const mode = this.elements.selectMode ? this.elements.selectMode.value : 'quiz';
        const category = (mode === 'roulette') ? 'karisik' : (this.elements.selectCategory ? this.elements.selectCategory.value : 'karisik');
        const maxClients = (mode === 'roulette') ? 4 : (this.elements.selectCapacity ? parseInt(this.elements.selectCapacity.value) : 2);
        const time = this.elements.selectTime ? parseInt(this.elements.selectTime.value) : 20;
        const privacy = this.elements.selectPrivacy ? this.elements.selectPrivacy.value : 'public';
        const isPrivate = privacy === 'private';

        // [SIMPLIFIED] Player Name from AuthManager
        let playerName = window.AuthManager ? window.AuthManager.getUsername() : "Misafir";

        // [FIX] Room Type: 'quiz' for normal, 'roulette' for Gaddar Rulet
        const roomType = (mode === 'roulette') ? 'roulette' : 'quiz';

        const options = {
            name: playerName, // [FIX] This is PLAYER name, sent to server onJoin
            character: window.AuthManager ? window.AuthManager.character : "karakter1.png", // [NEW]
            mode: mode,
            category: category,
            isPrivate: isPrivate,
            turnTime: time,
            maxPlayers: maxClients // [FIX] This goes to server onCreate
        };

        try {
            console.log(`Creating room [${roomType}] as [${playerName}] with options:`, options);
            await window.multiplayer.createRoom(roomType, options);

            // [FIX] Update UI with Room ID
            if (window.onlineManager) {
                window.onlineManager.onRoomJoined(window.multiplayer.room);
            }

            // On success, UI switches via onlineManager listening to state change or room join
            // Usually we go to waiting room
            ui.showScreen('waiting-room-screen');

            // [SYNC FIX] Setup listeners for Waiting Room settings
            this.setupWaitingRoomListeners();
        } catch (e) {
            console.error("Create Room Failed:", e);
            alert("Oda oluşturulamadı: " + e.message);
        }
    },

    joinRoom: async function (roomIdOverride, nameOverride) {
        const roomId = roomIdOverride || (this.elements.inputRoomId ? this.elements.inputRoomId.value.trim() : "");

        // Helper to show inline error
        const showInlineError = (msg) => {
            // Remove existing error
            const existing = document.getElementById('join-inline-error');
            if (existing) existing.remove();

            const errorDiv = document.createElement('div');
            errorDiv.id = 'join-inline-error';
            errorDiv.style.cssText = `
                background: linear-gradient(135deg, rgba(231,76,60,0.2), rgba(192,57,43,0.2));
                border: 1px solid rgba(231,76,60,0.4);
                border-radius: 10px;
                padding: 12px 18px;
                margin-bottom: 15px;
                color: #e74c3c;
                font-size: 0.9rem;
                text-align: center;
                animation: shake 0.3s ease-in-out;
            `;
            errorDiv.innerHTML = `⚠️ ${msg}`;

            // Insert before inputs
            const panel = document.getElementById('join-room-panel');
            const inputsRow = panel?.querySelector('div[style*="display: flex"]');
            if (inputsRow) {
                inputsRow.parentNode.insertBefore(errorDiv, inputsRow);
            }

            // Auto-remove after 4s
            setTimeout(() => errorDiv.remove(), 4000);
        };

        if (!roomId) {
            showInlineError("Lütfen bir Oda Kodu girin!");
            if (this.elements.inputRoomId) this.elements.inputRoomId.focus();
            return;
        }

        try {
            await window.multiplayer.joinRoom(roomId, {
                name: nameOverride,
                character: window.AuthManager ? window.AuthManager.character : "karakter1.png"
            });

            // [FIX] Update UI with Room ID
            if (window.onlineManager) {
                window.onlineManager.onRoomJoined(window.multiplayer.room);
            }

            // On success, redirects to waiting room or game via onlineManager callbacks
            ui.showScreen('waiting-room-screen');

            // [SYNC FIX] Setup listeners for Waiting Room settings
            this.setupWaitingRoomListeners();
        } catch (e) {
            console.error("Join Room Failed:", e);
            showInlineError("Odaya katılınamadı: " + e.message);
        }
    },

    refreshServerList: async function () {
        const container = this.elements.listContainer || document.getElementById('server-list-container');
        if (!container) return;

        container.innerHTML = '<div style="color:var(--dim-text); text-align:center; padding:20px;">Odalar aranıyor... 🔍</div>';

        try {
            const rooms = await window.multiplayer.getAvailableRooms();
            console.log("🔍 Server Rooms Raw:", rooms); // [DEBUG]
            container.innerHTML = '';

            const publicRooms = rooms.filter(r => {
                const isPriv = r.metadata && r.metadata.isPrivate;
                // Handle string 'true' just in case
                if (isPriv === "true" || isPriv === true) return false;
                return true;
            });
            console.log("🔍 Public Rooms Filtered:", publicRooms); // [DEBUG]

            if (publicRooms.length === 0) {
                container.innerHTML = `
                    <div style="color:var(--dim-text); text-align:center; padding:40px 20px;">
                        <span style="font-size:3rem; display:block; margin-bottom:10px;">📭</span>
                        Şu an aktif açık oda bulunamadı.<br>
                        <small style="opacity:0.6;">Kendi odanı kurarak başlatabilirsin!</small>
                    </div>
                `;
                return;
            }

            publicRooms.forEach(room => {
                const row = document.createElement('div');
                row.className = 'server-room-entry';

                const meta = room.metadata || {};
                const hostName = meta.hostName || meta.name || "Bilinmiyor";
                const cat = (meta.category || "KARIŞIK").toUpperCase();
                const players = `${room.clients}/${room.maxClients}`;
                const roomCode = meta.roomCode || room.roomId; // [NEW] Prefer Code

                // [FIX] Dynamically show mode badge
                let modeName = meta.mode === 'wheel' ? "🎡 ÇARK" : "📝 BİLGİ";


                // [SECURITY FIX] Safe DOM Creation
                const leftCol = document.createElement('div');
                leftCol.style.cssText = "text-align:left; flex:1;";

                const titleDiv = document.createElement('div');
                titleDiv.style.cssText = "color:var(--accent-gold); font-weight:bold; display:flex; align-items:center; gap:8px;";
                titleDiv.textContent = hostName + " ";

                const badgeSpan = document.createElement('span');
                badgeSpan.style.cssText = "font-size:0.6rem; background:rgba(255,255,255,0.1); padding:2px 6px; border-radius:4px; color:#aaa;";
                badgeSpan.textContent = modeName;
                titleDiv.appendChild(badgeSpan);

                const subDiv = document.createElement('div');
                subDiv.style.cssText = "font-size:0.75rem; color:var(--dim-text); margin-top:4px;";

                const codeSpan = document.createElement('span');
                codeSpan.style.cssText = "color:#fff; font-weight:bold; background:#333; padding:2px 5px; border-radius:3px; margin-right:5px;";
                codeSpan.textContent = roomCode;

                const catText = document.createTextNode(" • " + cat);

                subDiv.appendChild(codeSpan);
                subDiv.appendChild(catText);

                leftCol.appendChild(titleDiv);
                leftCol.appendChild(subDiv);

                const rightCol = document.createElement('div');
                rightCol.style.cssText = "text-align:right; display:flex; align-items:center; gap:15px;";

                const playersDiv = document.createElement('div');
                playersDiv.style.cssText = `font-family:'Outfit'; font-weight:800; color:${room.clients >= room.maxClients ? '#e74c3c' : '#2ecc71'};`;
                playersDiv.textContent = players;

                const joinBtn = document.createElement('button');
                joinBtn.className = "join-room-btn-list gaddar-btn mini";
                joinBtn.dataset.id = room.roomId;
                joinBtn.style.cssText = "padding: 8px 15px; font-size: 0.75rem;";
                joinBtn.textContent = "KATIL";

                rightCol.appendChild(playersDiv);
                rightCol.appendChild(joinBtn);

                row.appendChild(leftCol);
                row.appendChild(rightCol);

                container.appendChild(row);
            });

            container.querySelectorAll('.join-room-btn-list').forEach(btn => {
                btn.onclick = () => {
                    const roomId = btn.dataset.id;
                    const idInput = document.getElementById('join-room-id');
                    if (idInput) idInput.value = roomId;

                    // [SIMPLIFIED] Direct Join Logic - Use AuthManager
                    let name = window.AuthManager ? window.AuthManager.getUsername() : "Oyuncu";

                    this.joinRoom(roomId, name);
                };
            });

        } catch (e) {
            console.error("Lobby API Error:", e);
            container.innerHTML = '<div style="color:var(--accent-red); text-align:center; padding:20px;">⚠️ Liste alınamadı. Sunucu bağlantısını kontrol edin.</div>';
        }
    },

    updatePlayerList: function (state, mySessionId) {
        // [ROBUSTNESS] Always check for fresh elements if cached ones are missing
        if (!this.elements.playersList) {
            console.warn("LobbyManager: Players list not cached, searching...");
            this.elements.playersList = document.getElementById('connected-players');
            this.cacheElements();
        }

        // [NEW] Track Host Session ID
        if (state.masterSessionId) {
            this.masterSessionId = state.masterSessionId;
        }

        if (!state.players || !this.elements.playersList) {
            return false;
        }

        this.elements.playersList.innerHTML = '';
        this.elements.playersList.setAttribute('aria-live', 'polite');
        this.elements.playersList.setAttribute('role', 'list');
        this.elements.playersList.setAttribute('aria-label', 'Bağlı oyuncular listesi');
        let count = 0;
        let guestReadyCount = 0;
        let isHost = false;
        let amIReady = false;

        state.players.forEach((player, sessionId) => {
            count++;
            const isMe = (sessionId === mySessionId);
            if (isMe) {
                if (player.isHost) isHost = true;
                if (player.ready) amIReady = true;
            }

            const li = document.createElement('li');
            li.className = 'player-item';

            // [SECURITY FIX] Safe DOM Creation
            const avatar = document.createElement('div');
            avatar.className = "avatar";
            Object.assign(avatar.style, {
                width: '40px', height: '40px', borderRadius: '50%',
                background: 'rgba(0,0,0,0.3)', marginRight: '10px',
                overflow: 'hidden', border: '1px solid rgba(255,215,0,0.2)'
            });

            const avatarImg = document.createElement('img');
            const charFile = player.character || 'karakter1.png';
            avatarImg.src = new URL(`../../assets/images/characters/${charFile}`, import.meta.url).href;
            Object.assign(avatarImg.style, {
                width: '100%', height: '100%', objectFit: 'contain'
            });
            avatar.appendChild(avatarImg);

            // [NEW] Stable Color Generation based on SessionID
            const colors = ['#FF4136', '#2ECC40', '#0074D9', '#FFDC00', '#B10DC9', '#FF851B', '#39CCCC', '#F012BE'];
            // Simple hash function
            let hash = 0;
            for (let i = 0; i < sessionId.length; i++) {
                hash = sessionId.charCodeAt(i) + ((hash << 5) - hash);
            }
            const colorIndex = Math.abs(hash) % colors.length;
            const playerColor = colors[colorIndex];

            const nameSpan = document.createElement('span');
            nameSpan.className = "name";
            nameSpan.textContent = (player.name || "Misafir");
            nameSpan.style.color = playerColor;
            nameSpan.style.textShadow = `0 0 10px ${playerColor}40`;
            nameSpan.style.fontSize = "1.3rem"; // [FIX] Larger Font Size

            if (isMe) {
                nameSpan.classList.add('is-me');
                nameSpan.style.color = "var(--accent-gold)";
                nameSpan.style.textShadow = "0 0 15px rgba(255, 215, 0, 0.6)";
                nameSpan.style.fontSize = "1.4rem"; // [FIX] Even Larger for Self
            }

            li.appendChild(avatar);
            li.appendChild(nameSpan);

            if (player.isHost) {
                const hostBadge = document.createElement('span');
                hostBadge.className = "badge host";
                hostBadge.innerHTML = '<span style="margin-right:4px;">👑</span> KURUCU';
                hostBadge.title = "Oda Kurucusu";
                hostBadge.style.cssText = "background:linear-gradient(45deg, #f1c40f, #f39c12); color:#000; padding:2px 8px; border-radius:12px; font-size:0.7rem; font-weight:bold; box-shadow:0 2px 5px rgba(0,0,0,0.2);";
                li.appendChild(hostBadge);
            }

            const statusSpan = document.createElement('span');
            statusSpan.className = `status ${player.ready ? 'ready' : 'waiting'}`;

            // [FIX] Host is ALWAYS Ready visually
            if (player.isHost) {
                statusSpan.className = 'status ready';
                statusSpan.innerHTML = '<span class="icon">✅</span> HAZIR';
            } else {
                let statusHTML = player.ready
                    ? '<span class="icon">✅</span> HAZIR'
                    : '<span class="icon spin">⏳</span> Bekliyor...';
                statusSpan.innerHTML = statusHTML;
            }

            li.appendChild(statusSpan);

            // [NEW] KICK BUTTON (Only for Host, non-self)
            if (isHost && !isMe) {
                const kickBtn = document.createElement('button');
                kickBtn.className = "kick-player-btn";
                kickBtn.innerHTML = "🚫";
                kickBtn.title = "Oyuncuyu Odadan At";
                kickBtn.style.cssText = "background:none; border:none; margin-left:10px; cursor:pointer; font-size:1.2rem; filter:grayscale(1); transition: filter 0.2s;";
                kickBtn.onmouseover = () => kickBtn.style.filter = "none";
                kickBtn.onmouseout = () => kickBtn.style.filter = "grayscale(1)";

                kickBtn.onclick = (e) => {
                    e.stopPropagation();
                    if (this.showCustomConfirm) {
                        this.showCustomConfirm(
                            "Oda Yönetimi",
                            `${player.name || 'Bu oyuncu'} odadan atılsın mı? Tekrar giriş yapamayacaktır.`,
                            () => {
                                if (window.multiplayer && window.multiplayer.room) {
                                    window.multiplayer.room.send("kickPlayer", sessionId);
                                }
                            }
                        );
                    }
                };
                li.appendChild(kickBtn);
            }

            this.elements.playersList.appendChild(li);

            if (player.ready) guestReadyCount++;
        });

        console.log(`[Client Debug] Players List Count: ${count}, Guests Ready: ${guestReadyCount}`); // [DEBUG]

        // [AUTO-START LOGIC]
        // If I am Host, and we have enough players (MATCHING CAPACITY), and ALL guests are ready.
        const targetCapacity = state.maxPlayers || 2;
        const isWheelMode = state.mode === 'wheel';

        if (isHost && !isWheelMode && count >= targetCapacity && (count - 1) === guestReadyCount) {
            if (!this.autoStartTriggered) {
                console.log("🚀 ALL PLAYERS READY! Auto-starting in 1s...");
                this.autoStartTriggered = true;
                // Delay slightly to let UI update state to "Ready" visually
                setTimeout(() => {
                    if (window.multiplayer && window.multiplayer.room) {
                        window.multiplayer.startGame();
                    }
                }, 1000);
            }
        } else {
            // Reset trigger if condition fails (e.g. someone unreadies or leaves)
            this.autoStartTriggered = false;
        }

        // [NEW] Update Status Hint Text
        const statusHint = document.getElementById('wr-status-text');
        if (statusHint) {
            if (isWheelMode) {
                if (count < 2) {
                    statusHint.innerText = "GADDAR OYUNCU BEKLENİYOR...";
                } else {
                    const allSpun = state.selectedCategories.length >= 9;
                    statusHint.innerText = allSpun
                        ? "KATEGORİLER SEÇİLDİ! OYUN BAŞLIYOR..."
                        : "MOD: ŞANS ÇARKİ - Çarkın çevrilmesi bekleniyor...";
                }
            } else {
                statusHint.innerText = count < 2
                    ? "OYUNCU BEKLENİYOR..."
                    : ((count - 1) === guestReadyCount ? "HERKES HAZIR!" : "OYUNCULARIN HAZIR OLMASI BEKLENİYOR...");
            }
        }

        // [FIX] Update Waiting Room Player Count Badge
        const countBadge = document.getElementById('wr-player-count');
        if (countBadge) {
            const max = state.maxPlayers || 4;
            countBadge.innerText = `${count}/${max}`;
        }



        // [NEW] Logic for Buttons - Host vs Guest
        const startBtn = document.getElementById('lobby-start-game-btn');
        const readyBtn = document.getElementById('lobby-ready-btn');

        // Hide both first
        if (startBtn) startBtn.classList.add('hidden');
        if (readyBtn) readyBtn.classList.add('hidden');

        if (isHost) {
            // HOST: Show GREEN "BAŞLAT" button
            if (startBtn) {
                startBtn.classList.remove('hidden');
                startBtn.style.background = "linear-gradient(135deg, #27ae60, #2ecc71)";
                startBtn.style.color = "#fff";
                startBtn.style.border = "2px solid #27ae60";

                if (count >= 2) {
                    // [FIX] Hide start button if in wheel mode - use spins instead
                    if (state.mode === 'wheel') {
                        startBtn.classList.add('hidden');
                        startBtn.disabled = true;
                    } else {
                        startBtn.classList.remove('hidden');
                        startBtn.disabled = false;
                        startBtn.style.opacity = "1";
                        startBtn.innerText = "OYUNU BAŞLAT 🚀";
                    }
                } else {
                    startBtn.classList.remove('hidden');
                    startBtn.disabled = true;
                    startBtn.style.opacity = "0.5";
                    startBtn.innerText = "OYUNCU BEKLENİYOR...";
                }
            }
        } else {
            // GUEST: Show BLUE "HAZIR OL" button
            if (readyBtn) {
                readyBtn.classList.remove('hidden');
                if (amIReady) {
                    readyBtn.innerText = "HAZIR ✅";
                    readyBtn.style.background = "linear-gradient(135deg, #27ae60, #2ecc71)"; // Green when ready
                    readyBtn.style.color = "#fff";
                    readyBtn.style.border = "2px solid #27ae60";
                } else {
                    readyBtn.innerText = "HAZIR OL";
                    readyBtn.style.background = "linear-gradient(135deg, #2980b9, #3498db)"; // Blue
                    readyBtn.style.color = "#fff";
                    readyBtn.style.border = "2px solid #2980b9";
                }
            }
        }

        // [NEW] Synchronize Selected Categories List for all players
        const categoryList = document.getElementById('wr-collected-categories-list');
        if (categoryList && state.selectedCategories) {
            categoryList.innerHTML = '';
            state.selectedCategories.forEach(cat => {
                const item = document.createElement('div');
                item.className = 'slot filled';
                item.innerText = cat.replace(/_/g, ' ').toUpperCase();
                categoryList.appendChild(item);
            });
        }

        return isHost;
    },

    // [NEW] Update Waiting Room UI (Category, Time, etc.)
    updateWaitingRoomUI: function (state, isHost) {
        // Elements
        const els = {
            categoryContainer: document.getElementById('wr-category-container'),
            categorySelect: document.getElementById('wr-category-select'),
            categoryBadge: document.getElementById('wr-category-badge'), // Quiz uses this

            modeSelect: document.getElementById('wr-mode-select'),
            modeBadge: document.getElementById('wr-mode-badge'),

            timeSelect: document.getElementById('wr-time-select'),
            timeBadge: document.getElementById('wr-time-badge'),

            capacitySelect: document.getElementById('wr-max-players-select'),
            capacityBadge: document.getElementById('wr-max-players-badge'),

            privacySelect: document.getElementById('wr-privacy-select'),
            privacyBadge: document.getElementById('wr-privacy-badge'),

            // [FIX] Room Code Element
            roomCodeDisplay: document.getElementById('display-room-id'),
            wrSwitchWheelBtn: document.getElementById('wr-switch-wheel-btn'),
            wrWheelArea: document.getElementById('wr-wheel-area')
        };

        // [NEW] Toggle Wheel Area Visibility based on Mode
        if (els.wrWheelArea) {
            const isWheelMode = state.mode === 'wheel';
            if (isWheelMode) {
                els.wrWheelArea.classList.remove('hidden');
                // Re-init wheel if canvas is now visible
                if (window.wheel && !window.wheel.isSpinning) {
                    window.wheel.init('wr-wheel-canvas');
                }
            } else {
                els.wrWheelArea.classList.add('hidden');
            }
        }

        // [FIX] Always ensure Room Code is synced
        if (els.roomCodeDisplay && state.roomCode) {
            els.roomCodeDisplay.innerText = state.roomCode;
        }

        if (isHost) {
            // SHOW SELECTS, HIDE BADGES
            if (els.categorySelect) {
                els.categorySelect.classList.remove('hidden');
                els.categorySelect.value = state.category || "karisik";
            }
            if (els.categoryBadge) els.categoryBadge.classList.add('hidden'); // Quiz uses badge or custom UI? Quiz has badge.

            if (els.modeSelect) {
                els.modeSelect.classList.toggle('hidden', state.mode === 'wheel'); // Hide mode select too if it's wheel
                els.modeSelect.value = state.mode || "quiz";
            }
            if (els.modeBadge) els.modeBadge.classList.add('hidden');

            if (els.timeSelect) {
                els.timeSelect.classList.remove('hidden');
                els.timeSelect.value = state.turnTime || "20";
            }
            if (els.timeBadge) els.timeBadge.classList.add('hidden');

            if (els.capacitySelect) {
                els.capacitySelect.classList.remove('hidden');
                els.capacitySelect.value = state.maxPlayers || "2";
                // [ROULETTE] Lock capacity to 4 in roulette mode
                if (state.mode === 'roulette') {
                    els.capacitySelect.value = "4";
                    els.capacitySelect.disabled = true;
                } else {
                    els.capacitySelect.disabled = false;
                }
            }
            if (els.capacityBadge) els.capacityBadge.classList.add('hidden');

            if (els.privacySelect) {
                els.privacySelect.classList.remove('hidden');
                els.privacySelect.value = state.isPrivate ? "private" : "public";
            }
            if (els.privacyBadge) els.privacyBadge.classList.add('hidden');

            // [NEW] Show Switch Wheel Button if not in Wheel Mode (OR if in Wheel Mode to switch back)
            if (els.wrSwitchWheelBtn) {
                // Always show it for Host
                els.wrSwitchWheelBtn.classList.remove('hidden');

                if (state.mode === 'wheel') {
                    els.wrSwitchWheelBtn.innerText = "📝 KLASİK MODA GEÇ";
                    els.wrSwitchWheelBtn.style.background = "rgba(255, 255, 255, 0.1)";
                } else {
                    els.wrSwitchWheelBtn.innerText = "🎡 ŞANS ÇARKI MODUNA GEÇ";
                    els.wrSwitchWheelBtn.style.background = "linear-gradient(135deg, #9b59b6, #8e44ad)";
                }
            }

            // [NEW] Show Switch Roulette Button
            const wrRouletteBtn = document.getElementById('wr-switch-roulette-btn');
            if (wrRouletteBtn) {
                // Show if in Quiz Mode (to switch TO) or Roulette Mode (to switch FROM)
                if (state.mode === 'quiz' || state.mode === 'roulette') {
                    wrRouletteBtn.classList.remove('hidden');

                    if (state.mode === 'roulette') {
                        wrRouletteBtn.innerText = "📝 KLASİK MODA GEÇ";
                        wrRouletteBtn.style.background = "rgba(255, 255, 255, 0.1)";
                        wrRouletteBtn.style.cursor = 'pointer';
                        if (els.wrSwitchWheelBtn) els.wrSwitchWheelBtn.classList.add('hidden');
                    } else {
                        wrRouletteBtn.innerText = "🎰 GADDAR RULET";
                        wrRouletteBtn.style.background = "linear-gradient(135deg, #c0392b, #e74c3c)";
                        wrRouletteBtn.style.cursor = 'pointer';
                    }
                } else {
                    wrRouletteBtn.classList.add('hidden');
                }
            }

        } else {
            // HIDE SELECTS, SHOW BADGES
            if (els.wrSwitchWheelBtn) els.wrSwitchWheelBtn.classList.add('hidden');
            // [NEW] Hide roulette button for guests
            const wrRouletteBtnGuest = document.getElementById('wr-switch-roulette-btn');
            if (wrRouletteBtnGuest) wrRouletteBtnGuest.classList.add('hidden');

            if (els.categorySelect) els.categorySelect.classList.add('hidden');
            if (els.categoryBadge) {
                els.categoryBadge.classList.remove('hidden');
                els.categoryBadge.innerText = `Kategori: ${(state.category || "KARIŞIK").toUpperCase()}`;
            }

            if (els.modeSelect) els.modeSelect.classList.add('hidden');
            if (els.modeBadge) {
                els.modeBadge.classList.add('hidden'); // Hiding mode badge as requested
                const modeText = state.mode === 'wheel' ? 'ŞANS ÇARKİ' : (state.mode === 'roulette' ? '🎰 GADDAR RULET' : 'KLASİK BİLGİ');
                els.modeBadge.innerText = `Mod: ${modeText}`;
            }

            if (els.timeSelect) els.timeSelect.classList.add('hidden');
            if (els.timeBadge) {
                els.timeBadge.classList.remove('hidden');
                els.timeBadge.innerText = `${state.turnTime || 20}s`;
            }

            if (els.capacitySelect) els.capacitySelect.classList.add('hidden');
            if (els.capacityBadge) {
                els.capacityBadge.classList.remove('hidden');
                els.capacityBadge.innerText = `${state.maxPlayers || 2} Kişi`;
            }

            if (els.privacySelect) els.privacySelect.classList.add('hidden');
            if (els.privacyBadge) {
                els.privacyBadge.classList.remove('hidden');
                els.privacyBadge.innerText = state.isPrivate ? "GİZLİ" : "AÇIK";
            }
        }

        // [NEW] Auto-Hide Category in Wheel Mode
        const isWheel = state.mode === 'wheel';
        if (els.categoryContainer) {
            els.categoryContainer.style.display = isWheel ? 'none' : 'block';
        }
        // Safety: hide individual elements too
        if (isWheel) {
            if (els.categorySelect) els.categorySelect.classList.add('hidden');
            if (els.categoryBadge) els.categoryBadge.classList.add('hidden');
        }

        // [NEW] Wheel Mode Integration
        if (state.mode === 'wheel') {
            // [SYNC FIX] Setup listeners if not already done
            this.setupWaitingRoomListeners();

            // Toggle buttons visibility based on host status
            const spinBtn = document.getElementById('wr-spin-btn');
            const autoSpinBtn = document.getElementById('wr-auto-spin-btn');

            if (spinBtn) spinBtn.style.display = isHost ? 'block' : 'none';
        }
    },


    showCountdown: function (callback) {
        const overlay = document.createElement('div');
        overlay.id = 'game-countdown-overlay';
        Object.assign(overlay.style, {
            position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
            background: 'rgba(0,0,0,0.9)', zIndex: 10000,
            display: 'flex', justifyContent: 'center', alignItems: 'center',
            fontSize: '8rem', color: '#fff', fontWeight: 'bold'
        });
        document.body.appendChild(overlay);

        let seconds = 3;
        const count = document.createElement('div');
        count.innerText = seconds;
        overlay.appendChild(count);

        const interval = setInterval(() => {
            seconds--;
            if (seconds > 0) {
                count.innerText = seconds;
            } else {
                clearInterval(interval);
                count.innerText = "BAŞLA!";
                setTimeout(() => {
                    overlay.remove();
                    if (callback) callback();
                }, 500);
            }
        }, 1000);
    },

    showCustomConfirm: function (title, message, onConfirm) {
        const old = document.getElementById('custom-confirm-modal');
        if (old) old.remove();

        const modal = document.createElement('div');
        modal.id = 'custom-confirm-modal';
        Object.assign(modal.style, {
            position: 'fixed', top: '0', left: '0', width: '100%', height: '100%',
            background: 'rgba(0,0,0,0.7)', backdropFilter: 'blur(5px)',
            display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: '20000',
            fontFamily: "'Outfit', sans-serif"
        });

        const card = document.createElement('div');
        Object.assign(card.style, {
            background: '#222', padding: '25px', borderRadius: '15px',
            border: '1px solid rgba(255,255,255,0.1)',
            minWidth: '350px', maxWidth: '90%',
            boxShadow: '0 10px 30px rgba(0,0,0,0.5)',
            textAlign: 'center', color: '#fff'
        });

        card.innerHTML = `
            <div style="font-size:1.2rem; font-weight:bold; margin-bottom:10px;">${window.security ? window.security.sanitizeHTML(title) : title}</div>
            <div style="color:#aaa; margin-bottom:25px;">${window.security ? window.security.sanitizeHTML(message) : message}</div>
            <div style="display:flex; justify-content:center; gap:15px;">
                <button id="cc-cancel-btn" style="padding:10px 20px; border-radius:8px; border:1px solid #555; background:transparent; color:#fff; cursor:pointer;">İptal</button>
                <button id="cc-confirm-btn" style="padding:10px 20px; border-radius:8px; border:none; background:var(--accent-gold); color:#000; font-weight:bold; cursor:pointer;">Tamam</button>
            </div>
        `;

        modal.appendChild(card);
        document.body.appendChild(modal);

        document.getElementById('cc-cancel-btn').onclick = () => modal.remove();
        document.getElementById('cc-confirm-btn').onclick = () => {
            modal.remove();
            if (onConfirm) onConfirm();
        };
        modal.onclick = (e) => { if (e.target === modal) modal.remove(); };
    }
};

window.LobbyManager = LobbyManager;
